import axios from "axios";
import { store as storeNotification } from "react-notifications-component";
import {
	AUTH_ERROR,
	ROUTES_FAILED,
	ROUTES_RULES_FAILED,
	ROUTES_RULES_LOADED,
	ROUTES_RULES_LOADING,
	ROUTES_SAVED,
	ROUTES_SAVING,
	ROUTES_SAVING_FAILED,
} from "./types";

export const loadRoutes = (listdata) => (dispatch) => {
	dispatch({ type: ROUTES_RULES_LOADING });

	let formData = new FormData(); //formdata object
	console.log("fileUploadActions data=", listdata);

	listdata.data.map((listdata) => {
		formData.append(listdata.name, listdata.value); //append the values with key, value pair
	});

	const token = localStorage.getItem("token");
	const config = {
		headers: {
			"x-auth-token": token,
			"content-type": "application/json",
		},
	};

	axios
		.post(listdata.url, formData, config)
		.then((response) => {
			if (response.error)
				return dispatch({
					type: ROUTES_RULES_FAILED,
					payload: response.error,
				});
			dispatch({ type: ROUTES_RULES_LOADED, payload: response.data });

			console.log(response.data);
		})
		.catch((error) => {
			console.log("LoadRoute error=", error);
			dispatch({
				type: AUTH_ERROR,
				payload: "" + error,
			});

			return dispatch({
				type: ROUTES_FAILED,
				payload: error,
			});
		});
};

export const saveRoutes = (listdata) => (dispatch) => {
	dispatch({ type: ROUTES_SAVING });

	let formData = new FormData(); //formdata object
	console.log("saveRoutes data=", listdata);

	/*listdata.data.map(listdata => {
		formData.append(listdata.name, listdata.value); //append the values with key, value pair
    });
    */

	const token = localStorage.getItem("token");
	const config = {
		headers: {
			"x-auth-token": token,
			"content-type": "application/json",
		},
	};

	axios
		.post(listdata.url, { data: listdata.data }, config)
		.then((response) => {
			if (response.error) {
				return dispatch({
					type: ROUTES_SAVING_FAILED,
					payload: response.error,
				});
			}
			dispatch({ type: ROUTES_SAVED, payload: response.data });

			console.log("saveRoutes response.data", response.data);
			storeNotification.addNotification({
				title: "Routes Saving!",
				message: "Successful saved Routes",
				type: "success",
				insert: "top",
				container: "top-right",
				animationIn: ["animated", "fadeIn"],
				animationOut: ["animated", "fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});
		})
		.catch((error) => {
			console.log(error);
			storeNotification.addNotification({
				title: "Route saving!",
				message: "Failed to Save Route",
				type: "danger",
				insert: "top",
				container: "top-right",
				animationIn: ["animated", "fadeIn"],
				animationOut: ["animated", "fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});
			return dispatch({
				type: ROUTES_SAVING_FAILED,
				payload: error,
			});
		});
};

export const saveDocType = (listdata) => (dispatch) => {
	dispatch({ type: ROUTES_SAVING });

	let formData = new FormData(); //formdata object
	console.log("saveRoutes data=", listdata);

	/*listdata.data.map(listdata => {
		formData.append(listdata.name, listdata.value); //append the values with key, value pair
    });
    */

	const token = localStorage.getItem("token");
	const config = {
		headers: {
			"x-auth-token": token,
			"content-type": "application/json",
		},
	};

	axios
		.post(listdata.url, listdata.data, config)
		.then((response) => {
			if (response.data.docType) {
				dispatch({ type: ROUTES_RULES_LOADED, payload: response.data });

				console.log("saveDocType response.data", response.data);
				storeNotification.addNotification({
					title: "DocTypes Saving!",
					message: "Successful saved Doctype",
					type: "success",
					insert: "top",
					container: "top-right",
					animationIn: ["animated", "fadeIn"],
					animationOut: ["animated", "fadeOut"],
					dismiss: {
						duration: 5000,
						onScreen: true,
					},
				});
			}
		})
		.catch((error) => {
			console.log(error);
			storeNotification.addNotification({
				title: "DocTypes saving!",
				message: "Failed to Save Route",
				type: "danger",
				insert: "top",
				container: "top-right",
				animationIn: ["animated", "fadeIn"],
				animationOut: ["animated", "fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});
			return dispatch({
				type: ROUTES_SAVING_FAILED,
				payload: error,
			});
		});
};
